export const dossiersBasePath = 'dossiers';
export const detailDossierPath = ':idDossier';
export const dossiersCollectionBasePath = 'dossiers';
export const dossierValidationPath = ':idDossier/validation';
